import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { LibraryModuleModel } from '../../model/LibraryModel';
import { getAllCertificates } from '../../services/certificateService';
import { getUserDetails } from '../../services/userService';
import { getUserData } from '../../services/utilityServices';
import { parseJwt } from '../../utils/generalUtils';
import { Async } from '../reusableComponents/Async';
// import { BasePage } from '../reusableComponents/BasePage';
import { BasePage} from '../reusableComponents/BasePage';
import { ListPage } from '../reusableComponents/ListPage';
import { Loader } from '../reusableComponents/Loader/Loader';
import { ListItem } from './ListItem';
import './libraryPage.scss';
import { getRequestedModules } from 'src/services/moduleService';
// import { UserModel } from 'src/model/UserModel';
import { UserModel } from '../../model/UserModel';
import { CustomFlatButton } from '../reusableComponents/CutomFlatButton';
import { Dialog } from 'material-ui';




export interface ILibraryModuleListPageProps {
    instances: LibraryModuleModel[];
    userInstance: UserModel;
    userUID: string;
}

export interface ILibraryModuleListPageState {
    open: boolean;
}

export class LibraryModuleListPageImpl extends React.PureComponent<ILibraryModuleListPageProps, ILibraryModuleListPageState> {
    constructor(props: ILibraryModuleListPageProps) {
        super(props);
        this.state = { open: false};
    }

    public promise = async () => {
        const isAdmin = UserModel.isAdmin(this.props.userInstance);
        const isSuperAdmin = UserModel.isSuperAdmin(this.props.userInstance);
        if (isSuperAdmin) {
            await getRequestedModules('');
        }
    }

    public renderModuleList = () => {
        const isAdmin = UserModel.isAdmin(this.props.userInstance);
        return <ListPage
            instances={this.props.instances}
            listItemComponent={ListItem}
            searchPlaceHolder="Enter category, module name to search..."
            searchBy={['', 'moduleName', 'Category', 'organizationName', 'RequestedDate', 'Status']}
            pageHeadings={isAdmin ? ['#', 'User Name', 'Module Name', 'Category', 'Completed Date', 'Download'] : ['#', 'Module Name', 'Category', 'Organization', 'Requested Date', 'Status']}
            promise={this.promise}
            isSearchable={true}
            cols={isAdmin ? [1, 2, 2, 2, 3, 2] : [1, 3, 2, 2, 2, 2]}
            emptyListMessage="No Module Available"
            chartTitle = "LibraryModuleList"
        />;
    }

    public handleDeleteListItems = () => {
        this.setState({
            open: true
        });
    }
    
    public render() {
        return <BasePage className="request-list-page" title="Library Request List" icon="chalkboard">
            <Async
                identifier="LibraryListPage"
                promise={this.promise}
                loader={<Loader type="async" />}
                content={this.renderModuleList()}
                error={<Loader type="async" />}
            />
        </BasePage >;
    }
}
export function mapStateToProps(state) {
    const userUID = state.login.get('token') ? parseJwt(state.login.get('token')).UniqueID : getUserData().userUID;
    return {
        userUID,
        instances: LibraryModuleModel.list(),
        userInstance: UserModel.get(userUID)
    };
}
export const LibraryListPage = 
withRouter(connect<{}, {}, ILibraryModuleListPageProps>(mapStateToProps)(LibraryModuleListPageImpl) as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/LibraryRequest/LibraryListPage.tsx